const evidencePriorityQueryKeys = {
  list: () => ["evidence-priority", "list"],
  details: (id: number) => ["evidence-priority", "list", { id }],
};

export const EvidencePriorityQuery = {
  queryKeys: evidencePriorityQueryKeys,
};
